import config from '../config';

const getCountries = async () => {
  const response = await fetch(`${config.API_URL}/countries`);
  const text = await response.text();
  
  // HTML comment'i temizle
  const cleanText = text.replace(/<!--.*?-->/g, '').trim();
  
  try {
    const data = JSON.parse(cleanText);
    
    // API response formatı: { data: [...], log: {...}, message: "..." }
    // Bu yüzden data.data kullanıyoruz
    if (data && data.data && Array.isArray(data.data)) {
      return data.data;
    } else {
      console.error('Invalid data format:', data);
      return [];
    }
  } catch (error) {
    console.error('JSON parse error:', error);
    throw new Error('Invalid JSON response');
  }
};

const addCountry = async (formData) => {
  console.log('Sending FormData:', formData);
  
  const response = await fetch(`${config.API_URL}/countries`, {
    method: 'POST',
    body: formData // FormData direkt gönder
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to add country');
  }
  
  return response.json();
};

const deleteCountry = async (countryId) => {
  const response = await fetch(`${config.API_URL}/countries/${countryId}`, {
    method: 'DELETE'
  });
  
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to delete country');
  }
  
  return response.json();
};

const countryService = {
  getCountries,
  addCountry,
  deleteCountry
};

export default countryService;